import React from "react";
import Box from "@mui/material/Box";
import { Grid, MenuItem, TextField, Divider, Typography } from "@mui/material";
import { currencies } from "./currencies";
import ForexChart from "./ForexChart";

export default function ForexRates() {
  const [currency, setCurrency] = React.useState(currencies[0]);

  // handleCurrencyChange({})

  return (
    <Box>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ marginBottom: "10px" }}
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 12, md: 6 }}
      >
        <Grid item xs={12} md={6}>
          <TextField
            id="standard-select-year"
            select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
          >
            {currencies.map((currency) => (
              <MenuItem key={currency} value={currency}>
                {currency}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <ForexChart currency={currency} monthValue={1} />
        </Grid>
      </Grid>
    </Box>
  );
}
